import { useInView } from "framer-motion";
import { useRef } from "react";
import Lottie from "react-lottie-player/dist/LottiePlayerLight";

type IProps = {
  animation: "iceCream";
};

const getLottieAnimation = (animationType: string) => {
  switch (animationType) {
    case "iceCream": {
      return "/background-images/gronan-live/ice-cream.json";
    }
    default: {
      return "";
    }
  }
};

const LottieAnimation = ({ animation }: IProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true });

  return <div ref={ref}>{inView && <Lottie path={getLottieAnimation(animation)} loop play />}</div>;
};

export default LottieAnimation;
